import React from "react";

const ShippingDelivery = () => {
  return (
    <>
      {/* breadcrumb start */}
      <div
        className="cta4-section-area mkt150 bg-[#243A5E]"
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <div className="cta-content-area heading1">
                <h2 className="text-anime-style-3">Shipping & Delivery Policy</h2>
                <div className="space16" />
                <p>Your Plan, Our Fulfillment Promise</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* breadcrumb end */}

      <div className="w-full h4-pricing-wrapper pb-[60px] md:pb-[6rem] max-md:pt-[60px] max-md:px-[20px] md:pt-[100px] pricing_section_bg">
        <div className="theme-container mx-auto">
          <div className="w-full">
            <div className="md:px-[100px]">
                <ul>
                  <li>
                    1. Service orders are fulfilled by our empaneled health
                    providers through their qualified technicians or
                    phlebotomist or staff.
                  </li>
                  <li>
                    2. Product orders are shipped through registered domestic
                    courier companies and /or speed post only.
                  </li>
                  <li>
                    3. Orders are shipped within 0-7 days or as per the delivery
                    date agreed at the time of order confirmation and delivering
                    of the shipment subject to Courier Company / post office
                    norms.
                  </li>
                  <li>
                    4. We are not liable for
                    any delay in delivery by the courier company / postal
                    authorities and only guarantees to hand over the consignment
                    to the courier company or postal authorities within 0-7 days
                    rom the date of the order and payment or as per the delivery
                    date agreed at the time of order confirmation.
                  </li>
                  <li>
                    5. Delivery of all orders will be to the address provided by
                    the buyer.
                  </li>
                  <li>
                    6. Delivery of our services will be confirmed on your mail
                    ID as specified during registration. For any issues in
                    utilizing our services you may contact our helpdesk on
                    <a href="tel:18002681155" style={{ display: "inline" }}>
                    18002681155
                    </a>
                    or
                    <a
                      href="mailto:"
                      style={{ display: "inline" }}
                    >
                      support@kavatchhealthcare.com
                    </a>
                    .
                  </li>
                </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShippingDelivery;
